import Heading from "../../shared/ui/Typography/Heading";
import Text from "../../shared/ui/Typography/Text";
import { CompanyJoinRequestForm } from "../../features/companyJoinRequest";

// CompanyJoinRequestScreen — route landing for /companies/join-request.
// Mounts under MainLayout. Thin composition wrapper around the feature
// widget. No selectors, no dispatch, no state — all owned by the widget.

function CompanyJoinRequestScreen() {
  return (
    <section
      className="feature-company-join-request"
      id="Csection"
      tabIndex="-1"
    >
      <div className="container">
        <header className="feature-company-join-request__header">
          <Heading level={1} variant="page">
            Запит на приєднання до компанії
          </Heading>
          <Text as="p" size="sm" tone="secondary">
            Знайдіть компанію, додайте коротке повідомлення та надішліть запит
            адміністратору.
          </Text>
        </header>

        <CompanyJoinRequestForm />
      </div>
    </section>
  );
}

export default CompanyJoinRequestScreen;
